import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'igForm',
    'operaForm',
    'pmsType',
    'operaKioskForm',
    'operaAuthType',
    'ssdInterface',
    'ocimInterface'
  ]

  connect() {
    this.onPMSTypeChanged()
    this.onOperaAuthTypeChanged()
  }

  onPMSTypeChanged = () => {
    this.hidePMSForms();
    if (this.pmsTypeTarget.value === 'infogenesis') {
      this.igFormTarget.classList.remove('hidden')
    }

    if (this.pmsTypeTarget.value === 'opera') {
      this.operaFormTarget.classList.remove('hidden')
    }

    if (this.pmsTypeTarget.value === 'opera_kiosk') {
      this.operaKioskFormTarget.classList.remove('hidden')
    }
  }

  onOperaAuthTypeChanged = () => {
    if (!this.hasOperaAuthTypeTarget) return
    const selected = this.operaAuthTypeTargets.find(radio => radio.checked)
    if (!selected) return

    this.ssdInterfaceTarget.classList.add('hidden')
    this.ocimInterfaceTarget.classList.add('hidden')

    if (selected.value === 'ssd') {
      this.ssdInterfaceTarget.classList.remove('hidden')
    } else if (selected.value === 'ocim') {
      this.ocimInterfaceTarget.classList.remove('hidden')
    }
  }

  hidePMSForms() {
    this.igFormTarget.classList.add('hidden');
    this.operaFormTarget.classList.add('hidden');
    this.operaKioskFormTarget.classList.add('hidden')
  }
}
